import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import i18n from "i18next";
import { useSnackbar } from "notistack";
import PropTypes from "prop-types";
import { Container, Typography } from "@mui/material";
import Header from "../../components/layout/header/Header";
import Footer from "../../components/layout/Footer";
import OnboardingDialog from "../../components/dialogs/Onboarding";
import useAuth from "../../hooks/useAuth";
import useData from "../../hooks/useData";
import useSettings from "../../hooks/useSettings";
import "../../assets/styles/layout.css";

const Layout = ({ children, page }) => {
  const { enqueueSnackbar } = useSnackbar();
  const { t } = useTranslation();
  const { user, setOnboardingData } = useAuth();
  const { settings } = useSettings();
  const {
    socketData,
    startExport,
    startExportPdf,
    setSocketData,
    folder,
    resetReceivedObjects,
    resetFailedReceivedObjects,
    pageView,
    image,
  } = useData();

  useEffect(() => {
    if (settings.language) {
      i18n.changeLanguage(settings.language);
    } else {
      i18n.changeLanguage(user?.data?.locale);
    }
    // eslint-disable-next-line
  }, [settings, user]);
  const [openOnboardingDialog, setOpenOnboardingDialog] = useState(false);

  const handleCloseOnboardingDialog = () => {
    setOpenOnboardingDialog(false);
    setOnboardingData("export", folder.data.documentID[0], false);
  };
  const startWatchVideo = () => {
    setOnboardingData("export", folder.data.documentID[0], true);
  };
  const getSnackbar = (message, status) => {
    enqueueSnackbar(
      <Typography variant="body2" className="snackbar-msg">
        {t(message)}
      </Typography>,
      {
        variant: status,
        autoHideDuration:
          status === "error" ? null : displayOnboarding ? 1000 : 5000,
      }
    );
  };
  let displayOnboarding =
    (folder?.data?.type?.type === "Manuscript" ||
      folder?.data?.type?.type === "oldDoc") &&
    !user?.data.onboardingData.exportOnboarding.isChecked &&
    !user?.data.onboardingData.exportOnboarding.documentId.includes(
      folder?.data?.documentID[0]
    );

  useEffect(() => {
    if (socketData?.body?.downloadUrl && startExport) {
      const element = document.createElement("a");
      element.href = socketData?.body?.downloadUrl;
      document.body.appendChild(element);
      element.click();
      startExportPdf(false);
      setSocketData([]);
      resetReceivedObjects();
      resetFailedReceivedObjects();
      getSnackbar("successExport", "success");
      if (displayOnboarding) {
        setOpenOnboardingDialog(true);
      }
    }
  }, [socketData, startExport]);

  useEffect(() => {
    if (socketData?.body?.downloadUrl && !startExport) {
      setSocketData([]);
      resetReceivedObjects();
      resetFailedReceivedObjects();
      startExportPdf(null);
    }
  }, [socketData, startExport]);

  useEffect(() => {
    if (
      socketData?.body?.Status === "Fail" &&
      socketData?.body?.Type === "export"
    ) {
      getSnackbar("errorExportPdf", "error");
      setSocketData([]);
      resetReceivedObjects();
      resetFailedReceivedObjects();
      startExportPdf(null);
    }
  }, [socketData]);

  useEffect(() => {
    if (folder?.data?.exportStatus === "In progress") {
      startExportPdf(true);
    }
  }, [folder]);

  useEffect(() => {
    let numberPage = parseInt(image?.data?.id?.split("-")[1]);
    let faceNumber =
      folder?.data?.isTwoFaces && image?.data?.splitStatus === "ok"
        ? `(${parseInt(image?.data?.id?.slice(-1))})`
        : "";

    if (pageView === "workspace") {
      document.title = t("workspace");
    }
    if (pageView === "document-view" && folder?.data?.name) {
      document.title = folder?.data?.name;
    }
    if (pageView === "editor-view" && folder?.data?.name && numberPage) {
      document.title = `${folder?.data?.name} ${t(
        "page"
      )} ${numberPage} ${faceNumber}`;
    }
  }, [folder, image, pageView]);

  return (
    <>
      <OnboardingDialog
        onApply={handleCloseOnboardingDialog}
        onClose={handleCloseOnboardingDialog}
        open={openOnboardingDialog}
        startWatchVideo={startWatchVideo}
      />
      <div className="layout-container">
        <Header />
        <Container
          component="main"
          disableGutters={page === "EditorView"}
          maxWidth={page === "EditorView" ? "100%" : "lg"}
          sx={{
            margin: page && "auto",
          }}
        >
          {children}
        </Container>
        {page !== "EditorView" && <Footer />}
      </div>
    </>
  );
};

Layout.propTypes = {
  children: PropTypes.node,
};

export default Layout;
